import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-64',
  templateUrl: './cards10-examples-64.component.html'
})
export class Cards10Examples64Component {}
